module.exports = __webpack_public_path__ + "static/media/Virtual_Games_Small.4ab3ce05.jpg";